import { render } from "./tw-progress.vue?vue&type=template&id=a4585548"
import script from "./tw-progress.vue?vue&type=script&lang=js"
export * from "./tw-progress.vue?vue&type=script&lang=js"
script.render = render

export default script